import { cn } from "@/lib/utils"
import {
  SIDEBAR_DIVIDER_CLASS,
  SIDEBAR_DIVIDER_TIGHT_CLASS,
  SIDEBAR_DIVIDER_NONE_CLASS,
} from "./sidebar-constants"

interface SidebarDividerProps {
  variant?: "standard" | "tight" | "none"
  className?: string
}

export function SidebarDivider({
  variant = "standard",
  className,
}: SidebarDividerProps) {
  const variantClass =
    variant === "tight"
      ? SIDEBAR_DIVIDER_TIGHT_CLASS
      : variant === "none"
        ? SIDEBAR_DIVIDER_NONE_CLASS
        : SIDEBAR_DIVIDER_CLASS

  return <div className={cn(variantClass, className)} />
}
